// extracted by mini-css-extract-plugin
export default {"wrapper":"ChatInput-module__wrapper--ea604","input":"ChatInput-module__input--fe640","button":"ChatInput-module__button--e04e7"};